import { useCallback, useEffect, useState } from "react";
import useBillingApi from "../../standalone/apps/billing/src/api";
import { useAuth } from "../useAuth";
import { INVOICE_STATUS_TYPES } from "../../standalone/apps/billing/src/const/db";

export const publishToParent = (data, meta) => {
  window.parent.postMessage({ ...meta, from: "uzeli-dashboard", data }, "*");
};

export default () => {
  const [embedMode, setEmbedMode] = useState(false);

  const queryParams = new URLSearchParams(document.location.search);

  const { user, isAdmin } = useAuth();

  const { ONE_TIME_BILLING, INVOICE } = useBillingApi();

  const [dataObject, setDataObject] = useState({});

  const setField = (key, value) => {
    setDataObject((prev) => {
      setDataObject({ ...prev, [key]: value });
    });
  };

  const getField = (key) => dataObject[key];

  const publishLoginEvent = (data) => {
    publishToParent(data, { status: "loggedIn", type: "loginResponse" });
  };

  const publishPaymentMethodEvent = (data) => {
    publishToParent(data, {
      status: "paymentSelected",
      type: "paymentResponse",
    });
  };

  const createInvoice = async (data) => {
    // console.log("isAdmin", isAdmin);
    // console.log("createInvoice parameter data", data);
    // console.log("user?.id", user?.id);
    const res = isAdmin ?  await ONE_TIME_BILLING.createInInstallments(data.userId || user?.id, data)
      :  await ONE_TIME_BILLING.createInInstallmentsByUser(data.userId || user?.id, data);
    // console.log("createInvoice - response", res);
    return res;
  };

  const chargeInvoice = async (data) => {
    const res1 = await INVOICE.getInvoiceDetail(
      data.userId || user?.id,
      data.invoiceId
    );
    if (
      res1?.status === true &&
      [INVOICE_STATUS_TYPES.Unpaid, INVOICE_STATUS_TYPES.Fail].includes(
        res1?.data?.invoice?.status
      )
    ) {
      const res = await ONE_TIME_BILLING.chargeInvoice(
        data.userId || user?.id,
        data
      );
      return res;
    } 
      return res1;
    
  };

  const handleEmbedModeEvent = useCallback(
    (e) => {
      if (e.data?.from === "orders-growthzilla") {
      // console.log("event from orders-growthzilla", e);
        if (e.data.embedMode) {
          setEmbedMode(true);
        }
        if (e.data.createInvoice) {
          // console.log("data for createInvoice", e.data.invoiceData);
          createInvoice(e.data.invoiceData)
            .then((res) => {
              // console.log("response from createInvoice", res);
              publishToParent(res, { type: "invoiceResponse" });
            })
            .catch(() => {
              publishToParent({ status: false }, { type: "invoiceResponse" });
            });
        }
        if (e.data.chargeInvoice) {
          // invoiceData= {invoiceId, paymentMethodId}
          chargeInvoice(e.data.invoiceData)
            .then((res) => {
              publishToParent(res, { type: "invoiceResponse" });
            })
            .catch(() => {
              publishToParent({ status: false }, { type: "invoiceResponse" });
            });
        }
      }
    },
    [user]
  );

  useEffect(() => {
    window.addEventListener("message", handleEmbedModeEvent);
    return () => {
      window.removeEventListener("message", handleEmbedModeEvent);
    };
  }, [handleEmbedModeEvent]);

  useEffect(() => {
    if (queryParams.get("embed")) {
      setEmbedMode(true);
    }
    publishToParent({ status: true }, { type: "loaded" });
  }, []);

  return {
    embedMode,
    setEmbedMode,
    setField,
    getField,
    publishLoginEvent,
    publishPaymentMethodEvent,
  };
};
